import type { AsyncSequence } from "../types/AsyncSequence"

export function SafeIterable<T>(stream: AsyncSequence<T>): {
  stream: AsyncGenerator<T>
  error: Promise<Error | undefined>
} {
  let resolve: (value: Error | undefined) => void
  const error: Promise<Error | undefined> = new Promise(r => (resolve = r))

  const generator = async function* () {
    try {
      for await (const item of stream) {
        yield item
      }
    } catch (err) {
      return resolve(err instanceof Error ? err : new Error(String(err)))
    }
    return resolve(undefined)
  }

  return {
    stream: generator(),
    error,
  }
}
